import { useAccountDevices } from "../../logic/hooks/useAccountDevices.js";
import { DeviceManager } from "../Devices/DeviceManager.jsx";

export function AccountDevicesTab({ account }) {
  const deviceState = useAccountDevices(account.id);

  return (
    <DeviceManager
      {...deviceState}
      fixedAccountId={account.id}
      fixedAccountName={account.companyName}
      getAccountName={() => account.companyName}
      emptyHint={`Provision devices for ${account.companyName} to track hardware, SIMs, and connectivity.`}
    />
  );
}
